export const SORT = {
  firstMint: 0,
  lastMint: 1,
  mostRare: 2,
  leastRare: 3,
  unique: 4,
};